export default __webpack_public_path__ + "static/media/magnifying-glass.060fa3c8.svg";